import { Star } from "lucide-react";
import { cn } from "@/lib/utils";
import { Tool } from "@/types/tool";

interface ToolCardHeaderProps {
  tool: Tool;
  favicon: string | null;
  uploading: boolean;
  isOwner: boolean;
  onImageUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBusinessNameClick?: () => void;
}

const ToolCardHeader = ({ 
  tool, 
  onBusinessNameClick 
}: ToolCardHeaderProps) => {
  return (
    <div className="flex items-start justify-between gap-2 w-full">
      <div className="min-w-0 flex-1">
        <h3 
          onClick={onBusinessNameClick}
          className="font-semibold text-gray-900 break-words line-clamp-2 hover:text-purple-700 transition-colors duration-300 cursor-pointer"
        >
          {tool.name}
        </h3>
        <div className="flex items-center gap-1.5 mt-1">
          <div className="flex">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                className={cn(
                  "h-3.5 w-3.5 transition-colors duration-300",
                  i < Math.floor(tool.rating) 
                    ? "text-yellow-400 fill-yellow-400" 
                    : "text-gray-200"
                )}
              />
            ))}
          </div>
          <span className="text-xs text-gray-500">({tool.reviews.toLocaleString()})</span>
        </div>
      </div>
    </div>
  );
};

export default ToolCardHeader;